export const audioFiles = [
  '/audio/sarah/01-sarah_landing-01.m4a',
  '/audio/sarah/02-sarah_landing-02.m4a',
  '/audio/sarah/03-sarah_landing-03.m4a',
  '/audio/sarah/04-sarah_landing-04.m4a',
  '/audio/sarah/05-sarah_landing-05.m4a',
  '/audio/sarah/06-sarah_landing-06.m4a',
  '/audio/sarah/07-sarah_landing-07.m4a',
  '/audio/sarah/08-sarah_landing-08.m4a',
  '/audio/sarah/09-sarah_landing-09.m4a',
  '/audio/sarah/10-sarah_landing-10.m4a',
  '/audio/sarah/11-sarah_landing-11.m4a'
];
